const weblog = window.weblog;

function log(url) {
  if (!url) return;
  weblog.sendImmediately('CUSTOM', {
    key: 'FANGZHOU_IMAGE_ERROR',
    value: {
      imageUrl: url,
      pageUrl: location.href,
    },
  });
}

const loadImg = (url) => {
  if (!url) return Promise.reject(null);

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.onload = () => {
      resolve(url);
    };
    img.onerror = () => {
      reject(url);
    };
  });
};

// CDN 切换重试
async function retry(url, node) {
  if (!url || !node) return;
  const cdnHosts = [
    'ali2.a.kwimgs.com',
    `h1.static.yximgs.com`,
    `static.yximgs.com`,
    'ali-ec.static.yximgs.com',
    'f2.eckwai.com',
    'js-ec.static.yximgs.com',
  ];
  const tryCdnHosts = [
    'ali2.a.kwimgs.com',
    'tx2.a.kwimgs.com',
    'ali-ec.static.yximgs.com',
    'f2.eckwai.com',
    'js-ec.static.yximgs.com',
  ];
  const m = url.match(/^http(s)?:\/\/(.*?)\//);
  const host = m && m[2];
  let success = false;
  if (host && cdnHosts.includes(host)) {
    cdnHosts.splice(cdnHosts.indexOf(host), 1);
    const urls = tryCdnHosts.map((cdn) => {
      return url.replace('http:', 'https:').replace(host, cdn);
    });

    for (const item of urls) {
      try {
        const src = await loadImg(item);
        node.src = src;
        success = true;
        break;
      } catch (error) {
        // console.log(error)
      }
    }

    if (!success) {
      node.style.display = 'none';
    }
  }
}
window.addEventListener(
  'error',
  (event) => {
    const node = event.target as any;
    if (node && node.nodeName && node.nodeName.toLowerCase() == 'img') {
      const url = node.src;
      retry(url, node);
      setTimeout((v) => log(url));
    }
  },
  true,
);

// cdn容灾
function fillProtocol(url) {
  if (/^\/\//.test(url)) {
    return 'https:' + url;
  }
  return url;
}

function getIdcAvailHostname(hostname) {
  // @ts-ignore
  let domains = (window && window.DOMAINS) || '';
  let result = '' + domains[hostname];
  // 合法的 hostname 判断
  if (!/^(?:[\w\-]+\.)+\w{2,}$/.test(result)) {
    result = hostname;
  }
  return result;
}

const localHostname = (location && location.hostname) || '';
const BACKUP_IDC_DOMAIN = '.kwaigobuy.com';
const backupIDCReg = new RegExp(BACKUP_IDC_DOMAIN.replace(/\./g, '\\.') + '$');
const islocalKwaigobuy = backupIDCReg.test(localHostname);

export function getIdcAvailUrl(orgUrl) {
  let url = '';
  try {
    url = new URL(fillProtocol(orgUrl));
  } catch {
    // 提供的 orgUrl 为非法 url，或浏览器环境不支持 URL 对象的，全都原样返回
    return orgUrl;
  }

  url.hostname = getIdcAvailHostname(url.hostname);

  // 兜底 idc 逃生。如果当前根域为 kwaigobuy 且 url.hostname 的根域为 kwaixiaodian
  // 时，强制切到 kwaigobuy 上来
  if (islocalKwaigobuy) {
    url.hostname = url.hostname.replace(/\.kwaixiaodian\.com$/, BACKUP_IDC_DOMAIN);
  }

  let result = url.toString();

  if (url.pathname === '/' && !/\/$/.test(orgUrl)) {
    return result.replace(/\/$/, '');
  }

  return result;
}
